import { render, staticRenderFns } from "./personalServiceList.vue?vue&type=template&id=a6f82436&scoped=true&lang=html&"
import script from "./personalServiceList.vue?vue&type=script&lang=js&"
export * from "./personalServiceList.vue?vue&type=script&lang=js&"
import style0 from "./personalServiceList.vue?vue&type=style&index=0&id=a6f82436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f82436",
  null
  
)

export default component.exports